import * as React from 'react';
import { Menu, MenuButton, MenuItems, Transition } from '@headlessui/react';
import { merge } from '../../../helpers/Utility';

export enum DropdownOrigin {
  TOP_LEFT = 'origin-top-left left-0',
  TOP_RIGHT = 'origin-top-right right-0'
}

export interface DropdownProps extends React.HTMLAttributes<HTMLDivElement> {
  button?: React.ReactNode;
  origin?: DropdownOrigin;
}

export const Dropdown: React.FC<DropdownProps> = ({ button, children, origin = DropdownOrigin.TOP_LEFT }) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      {button ? <MenuButton>{button}</MenuButton> : null}
      <Transition
        as={React.Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems
          className={merge(
            origin,
            'absolute w-max rounded-md shadow-lg bg-primary-std ring-1 ring-black ring-opacity-5 focus:outline-none z-50'
          )}
        >
          {children}
        </MenuItems>
      </Transition>
    </Menu>
  );
};
